module.exports = __webpack_public_path__ + "static/media/movingHexagons.18fb8aa3.mp4";